<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ng-container *ngFor="let p of consulta?.lista; let i = index">

      <div class="row" [ngClass]="{'bg-light':!(i%2)}">
        <div class="d-flex align-items-center col-12 col-lg-5">
          <div>
            <img *ngIf="p?.tipoDocumento !='CNPJ'" src="/assets/images/consulta/icon-pf-blue.png" alt=""
              class="img-30x30" />
            <img *ngIf="p?.tipoDocumento =='CNPJ'" src="/assets/images/consulta/icon-pj-blue.png" alt=""
              class="img-30x30" />
          </div>
          <div class="p-2">
            <div class="text-secondary format-compacta">Nome:</div>
            <div class="format-compacta">{{p?.nomeProprietario || 'NÃO INFORMADO'}}</div>
          </div>
        </div>

        <div class="col-12 col-sm-7 col-lg-4  p-2">
          <div class="text-secondary format-compacta">Documento:</div>
          <div id="documentoPropHist" class="format-compacta">
            {{ p?.tipoDocumento }}
            {{p?.cgcCpf || 'NÃO INFORMADO'}}
          </div>
        </div>

        <div class="col-12 col-sm-5 col-lg-3 p-2">
          <div class="text-secondary format-compacta">Data de processamento:</div>
          <!--  <div class="format-compacta">{{p?.dataProcessamento ? (p?.dataProcessamento | date:'dd/MM/yyyy') : 'NÃO INFORMADO' }}</div> -->
          <div class="format-compacta">{{p?.dataProcessamento || 'NÃO INFORMADO' }}</div>
        </div>


      </div>

    </ng-container>

  </ng-container>

</app-card-consulta>



<!-- <div class="row" [ngClass]="{'bg-light':!(0%2)}">
      <div class="d-flex align-items-center col-12 col-lg-5 p-2">
        <div class="mr-2">
          <img src="/assets/images/consulta/icon-pf-blue.png" alt="" class="img-30x30" />
        </div>
        <div>
          <div class="text-secondary format-compacta">Nome:</div>
          <div class="format-compacta">{{p?.nomeProprietario || 'NÃO INFORMADO'}}</div>
        </div>
      </div>

      <div class="col-12 col-sm-7 col-lg-4  p-2">
        <div class="text-secondary format-compacta">Documento:</div>
        <div class="format-compacta">{{p?.tipoDocumento || 'CPF/CNPJ'}} - {{p?.documento || 'NÃO INFORMADO'}}</div>
      </div>

      <div class="col-12 col-sm-5 col-lg-3  p-2">
        <div class="text-secondary format-compacta">Data de processamento:</div>
        <div class="format-compacta">{{p?.dataProcessamento ? (p?.dataProcessamento | date:'dd/MM/yyyy') : 'NÃO INFORMADO' }}</div>
      </div>
    </div>

    <div class="row" [ngClass]="{'bg-light':!(1%2)}">
      <div class="d-flex align-items-center col-12 col-md-5 p-2">
        <div class="mr-2">
          <img src="/assets/images/consulta/icon-pf-blue.png" alt="" class="img-30x30" />
        </div>
        <div>
          <div class="text-secondary format-compacta">Nome:</div>
          <div class="format-compacta">{{p?.nomeProprietario || 'NÃO INFORMADO'}}</div>
        </div>
      </div>

      <div class="col-12 col-sm-7 col-md-4 p-2">
        <div class="text-secondary format-compacta">Documento:</div>
        <div class="format-compacta">{{p?.tipoDocumento || 'CPF/CNPJ'}} - {{p?.documento || 'NÃO INFORMADO'}}</div>
      </div>

      <div class="col-12 col-sm-5 col-md-3 p-2">
        <div class="text-secondary format-compacta">Data de processamento:</div>
        <div class="format-compacta">{{p?.dataProcessamento ? (p?.dataProcessamento | date:'dd/MM/yyyy') : 'NÃO INFORMADO' }}</div>
      </div>
    </div> -->
